// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38IuO","buttons":"styles_buttons__ge2-d"};